import { render, staticRenderFns } from "./ReservationAvailability.vue?vue&type=template&id=0280e35a&scoped=true"
import script from "./ReservationAvailability.vue?vue&type=script&lang=js"
export * from "./ReservationAvailability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0280e35a",
  null
  
)

export default component.exports